import * as store from '../transitions/transitions';

export const DebitAddOnSteps = [
	'bank/confirm-address',
	'bank/confirm-info',
	'bank/create-account',
	'bank/account-completed',
	'link-bank',
	'bank/debit-fund',
	'bank/fund-completed',
];

export const DebitAddOnTransitions = {
	'bank/confirm-address': [[store.hasConfirmedAddress, 'bank/confirm-info']],
	'bank/confirm-info': [[store.hasConfirmedEnrollment, 'bank/create-account']],
	'bank/create-account': [
		[store.hasStashDebitAndNoBankLinked, 'bank/account-completed'],
		[store.hasStashDebitAndHasBankLinked, 'bank/account-completed'],
	],
	'bank/account-completed': [
		[store.hasStashDebitAndNoBankLinked, 'link-bank'],
		[store.hasStashDebitAndHasBankLinked, 'bank/debit-fund'],
	],
	'link-bank': [[store.hasStashDebitAndHasBankLinked, 'bank/debit-fund']],
};

const DebitFlow = {
	name: 'DebitAddOnFlow',
	steps: DebitAddOnSteps,
	transitions: DebitAddOnTransitions,
	showProgressBarIcon: false,
};

export default DebitFlow;
